.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--sp-4);
}

.item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--sp-2);
  padding: var(--sp-5);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  text-align: left;
  cursor: pointer;
}

.item:hover {
  border-color: var(--border-strong);
  background: var(--surface-2);
}

.head {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  color: var(--text);
}

.label {
  font-weight: 600;
  font-size: var(--fs-md);
}

.desc {
  color: var(--text-3);
  font-size: var(--fs-sm);
}

/* «Из источника» — не восьмой тип блока, а другой способ его завести, поэтому
   стоит отдельной строкой под сеткой, за волосяным разделителем, а не ещё
   одной карточкой в ряду. */
.sourceRow {
  margin-top: var(--sp-5);
  padding-top: var(--sp-4);
  border-top: 1px solid var(--border);
}

.sourceBtn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--sp-1);
  width: 100%;
  padding: var(--sp-3) var(--sp-4);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  text-align: left;
  cursor: pointer;
}

.sourceBtn:hover {
  border-color: var(--border-strong);
  background: var(--surface-2);
}

.sourceLabel {
  color: var(--text);
  font-weight: 600;
  font-size: var(--fs-sm);
}

.sourceDesc {
  color: var(--text-3);
  font-size: var(--fs-xs);
}
